module.exports = __webpack_public_path__ + "img/tertiary_2x1.5370ede9.svg";